var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7722",
    "data-name": "Rectangle 7722",
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10731",
    "data-name": "Group 10731",
    transform: "translate(-3114 -705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-con-1",
    transform: "translate(3114 705)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#04b54b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_22528",
    "data-name": "Path 22528",
    d: "M51.077,40.442h2.771a3.344,3.344,0,0,0,3.539-3.111V35.755a4.76,4.76,0,0,0-2.481-4.017A30.126,30.126,0,0,0,39.693,28a30.11,30.11,0,0,0-15.212,3.739A4.76,4.76,0,0,0,22,35.755v1.577a3.344,3.344,0,0,0,3.539,3.111h2.771a2.51,2.51,0,0,0,2.654-2.333v-2.12a1.173,1.173,0,0,1,.826-1.092,25.422,25.422,0,0,1,15.807,0,1.173,1.173,0,0,1,.826,1.092v2.12a2.51,2.51,0,0,0,2.654,2.333Z",
    transform: "matrix(-0.719, -0.695, 0.695, -0.719, 3157.444, 799.19)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallicon);
export default __webpack_public_path__ + "static/media/callicon.b48be8a3bbd18286e8bf77ca4bec19a2.svg";
export { ForwardRef as ReactComponent };